import './css/TextMe.css';
import { translateSobre } from '../../data/translateSobre';
import { TextoSelecionado } from './Observer';

function TextMe({ language, setLanguage }) {

    const select = translateSobre[language].sobre;

    return (
        <section className="about-section">
          <div className='box-title-section'>
            <h3 id="about" className='back-legend'>{select.titulo}</h3>
            <h2 className='front-legend'>{select.titulo}</h2>
            
          </div>
          <div className='boxAboutMe'>
            <div className='about-text-content'>
            <p>{select.paragrafo1}</p>
            <p>{select.paragrafo2}</p>
            <p>{select.paragrafo3}</p>
            </div>
            <div className='aboutme'>
            </div>

          </div>
        </section>
      );
}

export default TextMe;